import * as React from "react"

import styles from "./image-grid.module.scss"
import classnames from "classnames/bind"
const cx = classnames.bind(styles)

export const ImageGrid = ({ children }) => (
  <span className={cx("image-grid")}>{children}</span>
)
